import { Injectable } from "@angular/core";
import { URLS } from '../../../config/api.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { map } from 'rxjs/operators';
import { environment } from "../../../environments/environment";
import { CommonService } from "../../helpers/common.service";
import { StorageServiceAAA } from "../../helpers/aaa-storage.service";
import { CustomEncryption } from "../../../config/custom-encrypt";
import moment from "moment";


@Injectable()
export class PayDetailsService {

	private payoutFDDetails = URLS.payoutFDDetails;
	private payoutBondsDetails = URLS.payoutBondsDetails;
	private payoutPmsDetails = URLS.payoutPmsDetails;
	private payoutMfDetails = URLS.payoutMfDetails;
	private payoutMldDetails = URLS.payoutMldDetails;
	private payoutNcdDetails = URLS.payoutNcdDetails;
	private payoutInsuranceDetails = URLS.payoutInsuranceDetails;
	private payoutAifDetails = URLS.payoutAifDetails;
	private payoutPtcDetails = URLS.payoutPtcDetails;
	private totalPayoutDetails = URLS.totalPayoutDetails;
	private eqPayoutDetails = URLS.eqPayoutDetails;
	private ClientWiseMFPayDetail = URLS.ClientWiseMFPayDetail;
	private taxPnlReport = URLS.taxPnlReport;

	public options:any
	private nativeHeaders = environment['nativeHeaders'];
	private gatewaySubscriptionKey = environment['gatewaySubscriptionKey'];
	private globalChecksumKey:any;
	env:any;

	constructor(private httpClient: HttpClient,
		private nativeHttp: HTTP,
		private commonService: CommonService,private cipherText: CustomEncryption,private storage: StorageServiceAAA) {
		this.storage.get('envSettings').then(res=>{
        this.env = res
		this.gatewaySubscriptionKey = res.gatewaySubscriptionKey
			this.globalChecksumKey = res.generalChecksumKey.globalChecksumKey
    })
	}

	
	// PayDetails FD
	public getPayoutDetails(cookievalue: any, requestCode: any, bodyParams: any, type: any): Observable<{}> {
		let isNew = false;
		let params: any;
		
		let obj: any = {
			'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa,
			'appID': localStorage.getItem('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		let setUrl;
		if (type == "fd") {
			isNew = true;
			setUrl = this.payoutFDDetails.url;
		}
		else if (type == "bond") {
			isNew = true;
			setUrl = this.payoutBondsDetails.url;
		}
		else if (type == "pms") {
			isNew = true;
			setUrl = this.payoutPmsDetails.url;
		}
		else if (type == "mld") {
			setUrl = this.payoutMldDetails.url;
		}
		else if (type == "ncd") {
			isNew = true;
			setUrl = this.payoutNcdDetails.url;
		}
		else if (type == "mf") {
			setUrl = this.payoutMfDetails.url;
		}
		else if (type == "insu") {
			setUrl = this.payoutInsuranceDetails.url;
		}
		else if (type == "aif") {
			isNew = true;
			setUrl = this.payoutAifDetails.url;
		}
		else if (type == "ptc") {
			setUrl = this.payoutPtcDetails.url;
		}
		else if (type == "eq") {
			setUrl = this.eqPayoutDetails.url;
		}
		if(isNew === true){
		const checkSumKey = this.cipherText.generateCheckSumKey()
		let checkSumString = '';
		const array = ['RMCode',
			"ClientCode",
			"PayoutMonth",
			"PageNo",
			"SearchBy",
			"SearchText",
			"SortBy",
			"SortOrder"]
		array.forEach(function (param) {
			if (bodyParams[param]) {
				checkSumString += bodyParams[param] + "_";
			} else if(param === 'PageNo' && bodyParams[param] === 0){
				checkSumString += bodyParams[param] + "_";
			}
		})
		checkSumString += checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
		const checkSum = this.cipherText.createChecksum(checkSumString, this.env.generalChecksumKey['globalChecksumKey'])
		bodyParams['RMCode'] = this.cipherText.createChecksum(bodyParams['RMCode'], checkSumKey);
		 params =
		{
			"head": {
				"requestcode": requestCode,
				"key": this.env.verifyRequestApi.key,
				"appver": "01",
				"appname": this.payoutFDDetails.appName,
				"osname": "Android",
				"userType": localStorage.getItem('userType'),
				"Checksum": checkSum,
				"Checksumkey": checkSumKey
			},
			"body": bodyParams
		}
		} else {
			params = 
			{
			"head":{
				"requestcode":requestCode ? requestCode : localStorage.getItem('userId1') ,
				"key":this.env.verifyRequestApi.key,
				"appver":"01",
				"appname": this.payoutFDDetails.appName,
				"osname":"Android",
				"userType": localStorage.getItem('userType')
			},
			"body": bodyParams
			}
		}

		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(setUrl, params, Object.assign(obj, this.nativeHeaders, this.options))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(setUrl, params, { headers: new HttpHeaders(Object.assign(obj)) });
	
	}

	public getTotalPayoutDetails(cookievalue: any, clientID: any, month: any): Observable<{}> {
		const checkSumKey = this.cipherText.generateCheckSumKey();
		const checkSumStr = clientID + "_" + month + "_" + checkSumKey + "_" + moment(new Date()).format('DDMMYYYY');
		const checkSum = this.cipherText.createChecksum(checkSumStr, this.globalChecksumKey);
		let params = {
			"head": {
				"RequestCode": "TotalPayoutDetails", "Key": this.env.verifyRequestApi.key,
				"AppName": this.totalPayoutDetails.appName, "AppVer": "1.0.4.0", "OsName": "Android",
				"Checksum": checkSum, "Checksumkey": checkSumKey,
				"userType": localStorage.getItem('userType')
			}, "body": { "RMCode": this.cipherText.createChecksum(clientID, checkSumKey), "PayoutMonth": month }
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
			'appID': localStorage.getItem('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(this.totalPayoutDetails.url, params, Object.assign(obj, this.nativeHeaders, this.options))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(this.totalPayoutDetails.url, params, { headers: new HttpHeaders(Object.assign(obj)) });
	}
	
	public getClientWiseMFPayDetail(cookievalue: any, body:any): Observable<{}> {

		//let params = body;
		let params =   
		{
			"head":
			{
				"RequestCode": "ClientWisePayDetail",
				"Key": this.env.verifyGuestandExtendedApi.key,
				"AppName": "AAA",
				"AppVer": "1.0.4.0",
				"OsName": "Android"
			},
			"body": body
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
			'appID': localStorage.getItem('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(this.ClientWiseMFPayDetail.url, params, Object.assign(obj, this.nativeHeaders, this.options))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(this.ClientWiseMFPayDetail.url, params, { headers: new HttpHeaders(Object.assign(obj)) });
	}
}